var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCanceledIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.9C5.86833 0.9 0.9 5.86833 0.9 12C0.9 18.1317 5.86833 23.1 12 23.1C18.1317 23.1 23.1 18.1317 23.1 12C23.1 5.86833 18.1317 0.9 12 0.9ZM12 21.9851C6.49702 21.9851 2.0149 17.5082 2.0149 12C2.0149 6.49702 6.4918 2.0149 12 2.0149C17.503 2.0149 21.9851 6.4918 21.9851 12C21.9851 17.5029 17.5029 21.9851 12 21.9851Z",
    fill: "#B20000",
    stroke: "#B20000",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6206 16.3162L15.6913 16.3869L15.762 16.3162L16.4087 15.6695L16.4794 15.5988L16.4087 15.5281L13.8133 12.9326L8.37976 7.49915L8.30905 7.42844L8.23833 7.49915L7.5914 8.14609L7.52069 8.2168L7.5914 8.28751L12.378 13.0741L15.6206 16.3162Z",
    fill: "#B20000",
    stroke: "#B20000",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37943 16.3162L8.30872 16.3869L8.23802 16.3162L7.59129 15.6695L7.52058 15.5988L7.59129 15.5281L10.1867 12.9326L15.6202 7.49915L15.691 7.42844L15.7617 7.49915L16.4086 8.14609L16.4793 8.2168L16.4086 8.28751L11.622 13.0741L8.37943 16.3162Z",
    fill: "#B20000",
    stroke: "#B20000",
    strokeWidth: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceledIcon);
export default __webpack_public_path__ + "static/media/canceled-icon.d59ab8f5843fb5f86ded2c3a96f28125.svg";
export { ForwardRef as ReactComponent };